import { useState } from "react";
import moment from 'moment'
import axios from 'axios'
import type { FormProps } from "antd";
import { Button, Form, Input, Radio, Select, message, Modal } from "antd";
import InputMask from "react-input-mask";

type FieldType = {
  source?: string;
  agentName?: string;
  customerRetained?: string;
  faxNumber?: string;
  hid?: string;
  customerName?: string;
  email?: string;
  phone?: string;
  currentPlan?: string;
  currentPrice?: string;
  billing?: string;
  reason?: string;
  offerUsed?: string;
  discount?: string;
  newProduct?: string;
  newPrice?: string;
  newBilling?: string;
  followResolved?: string;
  followSteps?: string;
  ticket?: string;
};


const MainForm: React.FC = () => {

  const [messageApi, contextHolder] = message.useMessage();

  const [form] = Form.useForm();

  const [customerRetained, setRetained] = useState('')
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isFetched, setIsFetched] = useState(true);

  const onFinish: FormProps<FieldType>["onFinish"] = async (values) => {
    console.log("Success:", values);
    setIsFetched(false)
    const data = {
        date: moment().format('DD-MM-YYYY'),
        agentName: values.agentName || '',
        source: values.source || '',
        customerRetained: values.customerRetained || '',
        faxNumber: values.faxNumber || '',
        hid: values.hid || '',
        customerName: values.customerName || '',
        email: values.email || '',
        phone: values.phone || '',
        currentPlan: values.currentPlan || '',
        currentPrice: values.currentPrice || '',
        billing: values.billing || '',
        reason: values.reason || '',
        offerUsed: values.offerUsed || '',
        discount: values.discount || '',
        newProduct: values.newProduct || '',
        newPrice: values.newPrice || '',
        newBilling: values.newBilling || '',
        followResolved: values.followResolved || '',
        followSteps: values.followSteps || '',
        ticket: values.ticket || '',
    }
    try {
        await axios.create({
          transformRequest: (): any => JSON.stringify(data),
        }).post("https://hooks.zapier.com/hooks/catch/4559531/2y5ybss/");
        
        setIsModalOpen(true)
    } catch (error) {
        console.log(error, 'error');
        
        messageApi.error('Form sending error');
    }
    setIsFetched(true)
  };

  return (
    <div className="main-wrapper">
        {contextHolder}
        <Modal title="Success!" open={isModalOpen} onCancel={() => {
            window.scrollTo({top: 0})
            setIsModalOpen(false)
            form.resetFields()
        }}>
            <p>Thank you, your request has been sent successfully</p>
        </Modal>
        <h1 className="title">
            Retention report
        </h1>
        <div className="date">
            <div className="label">Date:</div>
            {moment().format('DD-MM-YYYY')}
        </div>
        <Form
        name="main"
        initialValues={{ remember: true }}
        onFinish={onFinish}
        autoComplete="off"
        className="main-form"
        form={form}
        >
        <Form.Item<FieldType>
            label="Source of Retention "
            name="source"
            required
            rules={[{ required: true, message: "Field is required" }]}
        >
            <Select>
                <Select.Option value="Voice">Voice</Select.Option>
                <Select.Option value="Email">Email</Select.Option>
                <Select.Option value="Chat">Chat</Select.Option>
            </Select>
        </Form.Item>
        <Form.Item<FieldType>
            label="Agent name"
            name="agentName"
            required
            rules={[{ required: true, message: "Field is required" }]}
        >
            <Input />
        </Form.Item>

        <Form.Item<FieldType>
            label="Customer Retained?"
            name="customerRetained"
            required
            rules={[{ required: true, message: "Field is required" }]}
        >
            <Radio.Group>
                <Radio.Button onClick={() => setRetained('Yes')} value="Yes">Yes</Radio.Button>
                <Radio.Button onClick={() => setRetained('No')} value="No">No</Radio.Button>
            </Radio.Group>
        </Form.Item>

        <Form.Item<FieldType>
            label="Domain name/Fax Number"
            name="faxNumber"
            required
            rules={[{ required: true, message: "Field is required" }]}
        >
            <Input />
        </Form.Item>

        <Form.Item<FieldType>
            label="HID"
            name="hid"
            required
            rules={[{ required: true, message: "Field is required" }]}
        >
            <Input />
        </Form.Item>

        <Form.Item<FieldType>
            label="Customer Name"
            name="customerName"
            required
            rules={[{ required: true, message: "Field is required" }]}
        >
            <Input />
        </Form.Item>

        <Form.Item<FieldType>
            label="Email Adress"
            name="email"            
            required
            rules={[{ required: true, message: "Field is required" }]}
        >
            <Input type="email" />
        </Form.Item>

        <Form.Item<FieldType>
            label="Phone"
            name="phone"
            required
            rules={[{ required: true, message: "Field is required" }]}
        >
            <InputMask mask="999-999-9999">
                {/* @ts-ignore */}
                {(inputProps: any) => <input className="phone-input" {...(inputProps as any)} />}
            </InputMask>
        </Form.Item>

        <Form.Item<FieldType>
            label="Current Package/Plan"
            name="currentPlan"
            required
            rules={[{ required: true, message: "Field is required" }]}
        >
            <Input />
        </Form.Item>

        <Form.Item<FieldType>
            label="Current Price/Amount"
            name="currentPrice"
            required
            rules={[{ required: true, message: "Field is required" }]}
        >
            <Input />
        </Form.Item>

        <Form.Item<FieldType>
            label="Billing Term Yearly or Monthly"
            name="billing"
            required
            rules={[{ required: true, message: "Field is required" }]}
        >
            <Radio.Group>
                <Radio.Button value="Monthly">Monthly</Radio.Button>
                <Radio.Button value="Yearly">Yearly</Radio.Button>
            </Radio.Group>
        </Form.Item>

        <Form.Item<FieldType>
            label="Reason for Cancellation"
            name="reason"
            required
            rules={[{ required: true, message: "Field is required" }]}
        >
            <Select>
                <Select.Option value="Pricing">Pricing</Select.Option>
                <Select.Option value="Don't use anymore">Don't use anymore</Select.Option>
                <Select.Option value="Hosting Elsewhere">Hosting Elsewhere</Select.Option>
                <Select.Option value="Better Price Elsewhere">Better Price Elsewhere</Select.Option>
                <Select.Option value="Ongoing Performance Issues">Ongoing Performance Issues</Select.Option>
                <Select.Option value="Customer Service Issue">Customer Service Issue</Select.Option>
                <Select.Option value="Inappropriate Sale">Inappropriate Sale</Select.Option>
                <Select.Option value="Prefer Competitor Products">Prefer Competitor Products</Select.Option>
                <Select.Option value="Out of Business">Out of Business</Select.Option>
                <Select.Option value="Product Doesn't Exist">Product Doesn't Exist</Select.Option>
                <Select.Option value="Account Owner Died">Account Owner Died</Select.Option>
            </Select>
        </Form.Item>

        {customerRetained && (
            <Form.Item<FieldType>
                label="Offer/Discount Used"
                name="offerUsed"
            >
                <Select>
                    {customerRetained === 'Yes' ? (
                        <>
                            <Select.Option value="1 month credit - offered/accepted">1 month credit - offered/accepted</Select.Option>
                            <Select.Option value="20% off for 3 months - offered/accepted">20% off for 3 months - offered/accepted</Select.Option>
                            <Select.Option value="20% off for 6 months - offered/accepted">20% off for 6 months - offered/accepted</Select.Option>
                        </>
                    ) : (
                        <>
                            <Select.Option value="1 month credit - offered/declined">1 month credit - offered/declined</Select.Option>
                            <Select.Option value="20% off for 3 months - offered/declined">20% off for 3 months - offered/declined</Select.Option>
                            <Select.Option value="20% off for 6 months - offered/declined">20% off for 6 months - offered/declined</Select.Option>
                        </>
                    )}
                </Select>
            </Form.Item>
        )}

        {customerRetained && customerRetained === 'Yes' && (
            <>
                <Form.Item<FieldType>
                    label="Discount offered outside of dropdown?"
                    name="discount"
                >
                    <Input />
                </Form.Item>
                <Form.Item<FieldType>
                    label="New Product/Package"
                    name="newProduct"
                >
                    <Input />
                </Form.Item>
                <Form.Item<FieldType>
                    label="New Product/Package PRICE"
                    name="newPrice"
                >
                    <Input />
                </Form.Item>
                <Form.Item<FieldType>
                    label="NEW Billing Term Yearly or Monthly"
                    name="newBilling"
                >
                    <Radio.Group>
                        <Radio.Button value="Monthly">Monthly</Radio.Button>
                        <Radio.Button value="Yearly">Yearly</Radio.Button>
                    </Radio.Group>
                </Form.Item>
                <Form.Item<FieldType>
                    label="Follow Up needed/Resolved (notes)"
                    name="followResolved"
                >
                    <Input />
                </Form.Item>
                <Form.Item<FieldType>
                    label="Follow up Date or Next Steps (note)"
                    name="followSteps"
                >
                    <Input />
                </Form.Item>
                <Form.Item<FieldType>
                    label="Ticket Number (if applicable)"
                    name="ticket"
                >
                    <Input />
                </Form.Item>
            </>
        )}

        <Form.Item>
            <Button type="primary" htmlType="submit" disabled={!isFetched}>
            Submit
            </Button>
        </Form.Item>
        </Form>
    </div>
  );
};

export default MainForm;
